
import { computed } from '@vue/composition-api';
import { useAuthStore } from '~/store/modal/auth';
import { useUserStore } from '~/store/user';
interface Props {
  dislike: number;
  like: number;
  activeLike: boolean;
  activeDislike: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  dislike: {
    key: "dislike",
    required: false,
    type: Number,
    default: 0
  },
  like: {
    key: "like",
    required: false,
    type: Number,
    default: 0
  },
  activeLike: {
    key: "activeLike",
    required: false,
    type: Boolean,
    default: false
  },
  activeDislike: {
    key: "activeDislike",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const {
    enable: enableAuthModal
  } = useAuthStore();
  const userStore = useUserStore();
  const userAuth = computed(() => userStore.userAuth);
  function onPositive() {
    if (userAuth.value) {
      emit('positive');
    } else {
      enableAuthModal({
        onComplete: () => emit('positive')
      });
    }
  }
  function onNegative() {
    if (userAuth.value) {
      emit('negative');
    } else {
      enableAuthModal({
        onComplete: () => emit('negative')
      });
    }
  }
  return {
    onPositive,
    onNegative
  };
};
export default __sfc_main;
